import './Offcanvas.scss';
import cn from 'classnames';
import { ReactNode } from 'react';
import { Offcanvas as RBOffcanvas } from 'react-bootstrap';

export const OffcanvasPlacement = {
  START: 'start',
  END: 'end',
  TOP: 'top',
  BOTTOM: 'bottom'
} as const;
export type OffcanvasPlacementType = (typeof OffcanvasPlacement)[keyof typeof OffcanvasPlacement];

interface OffcanvasProps {
  show: boolean;
  onHide: () => void;
  placement?: OffcanvasPlacementType;
  width?: string;
  header?: ReactNode;
  className?: string;
  ariaLabel?: string;
  children: ReactNode;
}

export const Offcanvas = ({
  show,
  onHide,
  placement = OffcanvasPlacement.END,
  width = '600px',
  header,
  className,
  ariaLabel,
  children
}: OffcanvasProps) => {
  const isHorizontal =
    placement === OffcanvasPlacement.START || placement === OffcanvasPlacement.END;
  const sizeStyle = isHorizontal ? { width } : { height: width };

  return (
    <RBOffcanvas
      show={show}
      onHide={onHide}
      placement={placement}
      className={cn('bpm-offcanvas', className)}
      style={sizeStyle}
      aria-label={ariaLabel}
    >
      {header && <div className='bpm-offcanvas-header'>{header}</div>}
      <div className='bpm-offcanvas-body'>{children}</div>
    </RBOffcanvas>
  );
};
